import runtimeConfig from '~config/config';

const { apiUrls } = runtimeConfig;

export function getAllBrands(r15Svc) {
    return r15Svc.get(`${apiUrls.catalogService}/brands`);
}

export default getAllBrands;
